/**
 * clientID courant persisté (sélecteur d'établissement). Écrit par
 * useLocalStorageSelect/usehooks-ts, qui l'encode en JSON (`"abc"`) : une
 * lecture brute garderait les guillemets. Ne jette jamais (Safari privé).
 */
export function readStoredClientID(): string {
    try {
        const raw = localStorage.getItem('clientID');
        if (!raw) return '';
        try {
            const parsed = JSON.parse(raw);
            return typeof parsed === 'string' ? parsed : '';
        } catch {
            return raw; // valeur héritée non JSON
        }
    } catch {
        return ''; // localStorage indisponible
    }
}
